"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POIntentStatus = exports.POStatus = void 0;
// -------------------------------------
// PURCHASE ORDER
// -------------------------------------
var POStatus;
(function (POStatus) {
    POStatus["Pending"] = "pending";
    POStatus["Approved"] = "approved";
    POStatus["Rejected"] = "rejected";
    POStatus["Resubmitted"] = "resubmitted";
    POStatus["Canceled"] = "canceled";
})(POStatus = exports.POStatus || (exports.POStatus = {}));
var POIntentStatus;
(function (POIntentStatus) {
    POIntentStatus["Pending"] = "Pending";
    POIntentStatus["AwaitingApproval"] = "Awaiting approval";
    POIntentStatus["Rejected"] = "Rejected";
    POIntentStatus["Approved"] = "Approved and awaiting transaction";
    POIntentStatus["Done"] = "Transaction complete";
})(POIntentStatus = exports.POIntentStatus || (exports.POIntentStatus = {}));



//////////////////
// WEBPACK FOOTER
// ./src/shared/purchase-order.ts
// module id = 2814
// module chunks = 0